module.exports = __webpack_public_path__ + "static/media/4.246b3e52.JPG";